<div class="es-batch-wrapper">
  <div class="es-batch-files" [ngClass]="{ 'es-batch-files-attached': isAddedAdditionalDocs }">
    <document-upload-placeholder
      header="UPLOAD_YOUR_ERP_REPORT"
      headerUploaded="ERP_REPORT"
      (upload)="onUploadERPFile($event)"
      (remove)="onRemoveERPFile()"
    ></document-upload-placeholder>

    <document-upload-multiple-placeholder
      header="ADD_DOCUMENTS_FOR_ALL_ENTRIES"
      headerHint="ADD_DOCUMENTS_FOR_ALL_ENTRIES_HINT"
      isSmallIcon="true"
      [id]="'file-input-multiple'"
      [validators]="validators"
      [allowedFileMimes]="allowedAdditionalFileMimes"
      (upload)="onUpdateAdditionalFile($event)"
    ></document-upload-multiple-placeholder>

    <div class="es-batch-checkbox">
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="auto-confirm" [formControl]="autoConfirmFc" />
          <label class="custom-control-label lcl-booking-hazard-disclaimer-label" for="auto-confirm">
            {{ "AUTOMATICALLY_CONFIRM_FILING" | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="es-batch-button">
      <button type="button" class="btn btn-primary" *ngIf="!!uploadedERPFile" (click)="create()">{{ "BUTTON.CREATE" | translate }}</button>
    </div>
  </div>

  <div class="es-batch-template" *ngIf="!isAddedAdditionalDocs">
    <div class="es-batch-template-text">
      <div class="es-batch-template-text-header">{{ "DOWNLOAD_SAMPLE_BLANK" | translate }}</div>
      <div class="es-batch-template-text-hint">{{ "DOWNLOAD_SAMPLE_BLANK_HINT_ERP" | translate }}</div>
    </div>
    <div class="es-batch-template-link">
      <div class="es-batch-template-link-download" (click)="downloadSample()">
        <img alt="download" src="/assets/icons/icon_download_sm_blue.svg" class="ml-2" />
        <span>{{ "BUTTON.DOWNLOAD" | translate }}</span>
      </div>
    </div>
  </div>

  <a #link class="d-none" download></a>
</div>

<loading-spinner [show]="isLoading"></loading-spinner>
